import React from 'react'
import useGlobals from 'sb-hooks/useGlobals'


const ZinaChecker = () => {
  const { isZinaEnabled } = useGlobals(({ globals: { isZinaEnabled } }) => ({ isZinaEnabled }))

  return (
    <div data-zina-status={isZinaEnabled ? 'on' : 'off'} />
  )
}


export default React.memo(ZinaChecker)
